function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import axios from 'axios';

var prepareSuccessPayload = function prepareSuccessPayload(response) {
  return response.data;
};

export var createDriver = function createDriver(axiosInstance) {
  return {
    requestInstance: axiosInstance,
    getAbortSource: function getAbortSource() {
      return axios.CancelToken.source();
    },
    abortRequest: function abortRequest(abortSource) {
      abortSource.cancel();
    },
    sendRequest: function sendRequest(requestConfig, abortSource) {
      return axiosInstance(_extends({
        cancelToken: abortSource.token
      }, requestConfig));
    },
    getSuccessPayload: function getSuccessPayload(response) {
      if (Array.isArray(response)) {
        return response.map(prepareSuccessPayload);
      }

      return prepareSuccessPayload(response);
    },
    getErrorPayload: function getErrorPayload(error) {
      return error;
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-requests-axios/es/axios-driver.js
// module id = 1843
// module chunks = 0